import type { Middleware } from "@reduxjs/toolkit";
import type { RootState } from "../rootReducer";
import { getAppConfiguration } from "appConfig";

const loggerMiddleware: Middleware<unknown, RootState> =
  (storeAPI) => (next) => async (action) => {
    const appConfiguration = await getAppConfiguration();
    if (appConfiguration.basePath !== "https://dashboard.eventjinny.com") {
      console.log("Dispatching action:", action);
      const result = next(action);
      console.log("Next state:", storeAPI.getState());
      return result;
    }
    return next(action);
  };

export default loggerMiddleware;
